module.exports = __webpack_public_path__ + "static/img/zjm.a78f859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjm.png
// module id = UL+v
// module chunks = 0